import Vue from 'vue'
import App from './App.vue'
import firebase from "firebase/app";
import "firebase/analytics";

import './registerServiceWorker'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import Notifications from 'vue-notification'
import '@/assets/theme.scss';
import 'nprogress/nprogress.css';
import vueAwesomeCountdown from 'vue-awesome-countdown'


Vue.config.productionTip = false
Vue.use(Buefy);
Vue.use(Notifications);
Vue.use(vueAwesomeCountdown, 'vac')

const firebaseConfig = {
  apiKey: "AIzaSyCJTjn_px41W3WsUFjvxI7s-b7CFDN6ZZA",
  authDomain: "jackpothousie-com.firebaseapp.com",
  databaseURL: "https://jackpothousie-com-default-rtdb.firebaseio.com",
  projectId: "jackpothousie-com",
  storageBucket: "jackpothousie-com.appspot.com",
  messagingSenderId: "1099110700614",
  appId: "1:1099110700614:web:4d1e9132e8608fa1da1c47",
  measurementId: "G-DJ21NNPZWK"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
